import { render, staticRenderFns } from "./guessing-bet-gold.vue?vue&type=template&id=3a84eb70&scoped=true&"
import script from "./guessing-bet-gold.vue?vue&type=script&lang=js&"
export * from "./guessing-bet-gold.vue?vue&type=script&lang=js&"
import style0 from "./guessing-bet-gold.vue?vue&type=style&index=0&id=3a84eb70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a84eb70",
  null
  
)

export default component.exports